<template>
  <q-item>
    <q-item-section>
      <q-item-label>Core Temperature</q-item-label>
    </q-item-section>

    <q-item-section side>
      <q-badge color="green-3" label="14 °C" />
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  name: 'SingleReadingItem'
}

</script>
